// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import {
    useShipmentHistoryDebouncedUpdateDraftParameter,
    useShipmentHistoryState,
} from "@store/Framework/Store/Greif/Pages/ShipmentHistory/ShipmentHistoryHooks";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC, useEffect, useMemo, useState } from "react";

export interface ShipmentHistoryFilterFieldPoNumberProps {}

export interface ShipmentHistoryFilterFieldPoNumberStyles {
    textField?: TextFieldPresentationProps;
}

export const shipmentHistoryFilterFieldPoNumberStyles: ShipmentHistoryFilterFieldPoNumberStyles = {
    textField: filterDrawerProps.textField,
};

const styles = shipmentHistoryFilterFieldPoNumberStyles;

const ShipmentHistoryFilterFieldPoNumber: FC<ShipmentHistoryFilterFieldPoNumberProps> = () => {
    const { purchaseOrderNumber } = useShipmentHistoryState().draftParameter;
    const debouncedUpdateDraftParameter = useShipmentHistoryDebouncedUpdateDraftParameter();
    const [value, setValue] = useState(purchaseOrderNumber);
    const id = useMemo(uniqueId, []);

    useEffect(() => {
        if (value !== purchaseOrderNumber) {
            setValue(purchaseOrderNumber);
        }
    }, [purchaseOrderNumber]);

    const label = translate("PO #");

    return (
        <FilterDrawerSection title={label} labelFor={id}>
            <TextField
                {...styles.textField}
                data-test-selector="shipmentHistory_poNumberFilter"
                id={id}
                onChange={event => {
                    setValue(event.currentTarget.value);
                    debouncedUpdateDraftParameter({ purchaseOrderNumber: event.currentTarget.value });
                }}
                placeholder={translate("Enter {0}", label)}
                value={value}
            />
        </FilterDrawerSection>
    );
};

export default ShipmentHistoryFilterFieldPoNumber;
